import Splide from '@splidejs/splide';

const SELECTORS = {
    block: '.wp-block-ssm-product-components-slider',
    carousel: '.splide',
};

const DEFAULT_OPTIONS = {
    autoWidth: true,
    arrows: true,
    pagination: false,
    rewind: false,
    gap: '0.75rem',
    drag: 'free',
    snap: true,
    dragMinThreshold: 5,
    flickPower: 200,
    trimSpace: false,
};

export function initProductComponents(block, isEditor = false) {
    const carousel = block.querySelector(SELECTORS.carousel);

    // Skip if already initialized
    if (!carousel || carousel.splide) {
        return null;
    }

    try {
        // const hasArrows = carousel.querySelector('.splide__arrows') !== null;

        const options = {
            ...DEFAULT_OPTIONS,
            ...(isEditor && { drag: false }),
        };

        const splide = new Splide(carousel, options);

        splide.on('overflow', function (isOverflow) {
            if (isOverflow) {
                splide.Components.Elements.list.classList.remove('justify-left');
            } else {
                splide.Components.Elements.list.classList.add('justify-left');
            }
        });

        splide.mount();

        return {
            destroy() {
                if (splide && typeof splide.destroy === 'function') {
                    splide.destroy();
                }
                delete carousel.splide;
            },
        };
    } catch (error) {
        console.error('Error initializing Product Components carousel:', error, carousel);

        return null;
    }
}

export function ProductComponents() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initProductComponents(block);
    });
}
